/**
 * 改为从环境变量中获取，之前的先注释，方便对比确认环境变量是否正确
 * 区分线上环境(build)/开发环境(dev)/测试环境(test)
 * **/
// 优先使用 VUE_APP_ENV 环境变量判断，如果没有则使用 URL 检测
const isProductionByEnv = ENV_DATA.VITE_APP_ENV.includes('production');

export const isBuild = isProductionByEnv;
/** url地址
 * HOST:
 * BOSH_SERVICE : strophe http-bind
 * FILE_UPLOAD: 文件上传地址
 * IMAGE_UPLOAD: 图片上传地址
 * WHITELIST_DOWNLOAD:白名单模板下载地址
 */

// app下载地址
export const DOWNLOAD_APP_URL = 'https://url.cloud.huawei.com/o9wcdVV8ju?shareTo=qrcode';
export const DOWNLOAD_APP_QRCODE = 'https://image.comein.cn/web/roadshow/co_download_qrc.png';
/** 接口版本号 **/
export const PORTVERSION = '4.2.0800';

// let httpHost;
// let host;
// let html;
// let bosh_service;
// let file_upload;
// let image_upload;
// let whitelist_download;
// let gfHost;
// let outBoundCall_download;
// let socket_url;
// let socket_ip;
// let irm_url;
// let net_url;
// let pdf_viewer_url;
// let file_viewer_url;
// let mobile_url;
// let comeinUrl;
// let srs_url;
// let webinapp_url;
// let mobile_institute_url;
// let portal_homepage;
// let portal_roadshow_url;
// let net_roadshow_url;
// let openmonitor_url;
// let srs_mobile_url;
// let clientUrl;
// let origin;
// let onlinePreviewMobile;
// let cloudonlinePreviewMobile;
// let slsProject;

// if (isBuild) {
//   // 国内正式环境
//   httpHost = 'https://server.comein.cn';
//   host = 'https://server.comein.cn/comein/index.php';
//   bosh_service = 'https://im.comein.cn:7443/http-bind/';
//   file_upload = 'https://server.comein.cn/comein/file.upload';
//   image_upload = 'https://server.comein.cn/comein/image.upload';
//   whitelist_download = 'https://resource.comein.cn/comein-files/img/roleLogo/whiteExcel_v1.xlsx';
//   outBoundCall_download = 'https://resource.comein.cn/comein-files/img/roleLogo/outBoundCall.xlsx';
//   socket_url = 'wss://im.comein.cn:7443/ws/';
//   socket_ip = 'server.comein.cn';
//   irm_url = 'https://irm.comein.cn';
//   net_url = 'https://srs.comein.cn';
//   srs_url = 'https://stocke.comein.cn';
//   html = 'https://resource.comein.cn/comein-files/';
//   pdf_viewer_url = 'https://mobile.comein.cn/pdfviewer/web/viewer.html?file=';
//   file_viewer_url = 'https://file-view.comein.cn/onlinePreview?url=';
//   mobile_url = 'https://mobile.comein.cn';
//   comeinUrl = 'https://server.comein.cn/comein';
//   webinapp_url = 'https://resource.comein.cn/comein-files/static/webinapp/#/';
//   mobile_institute_url = 'https://mobile.comein.cn/mobile/institute/home?comein_channel=';
//   portal_homepage = 'https://www.comein.cn';
//   portal_roadshow_url = 'https://www.comein.cn/roadshow/home/';
//   net_roadshow_url = 'https://net.comein.cn/roadshow/home/';
//   openmonitor_url = 'https://openmonitor.comein.cn';
//   srs_mobile_url = 'https://srs-m.comein.cn';
//   clientUrl = 'https://client.comein.cn';
//   origin = 'https://brm.comein.cn';
//   onlinePreviewMobile = 'https://mobile.comein.cn/onlinePreview/onlinePreview?url=';
//   cloudonlinePreviewMobile = 'https://mobile.comein.cn/mobile/cloud-preview?documentId=';
//   slsProject = 'comein-web';
// } else {
//   // 国内测试环境
//   httpHost = 'https://testserver.comein.cn';
//   host = '/api/comein/index.php';
//   gfHost = 'ws://meeting-socket.test.wlan.comein.cn:8837/';
//   bosh_service = 'https://imtest.comein.cn:7443/http-bind/';
//   file_upload = 'https://testserver.comein.cn/comein/file.upload';
//   image_upload = 'https://testserver.comein.cn/comein/image.upload';
//   whitelist_download = 'https://testserver.comein.cn/comein-files/img/roleLogo/whiteExcel_v1.xlsx';
//   outBoundCall_download = 'https://testserver.comein.cn/comein-files/img/roleLogo/outBoundCall.xlsx';
//   socket_url = 'wss://im-test.comein.cn:7443/ws/';
//   socket_ip = 'testserver.comein.cn';
//   irm_url = 'https://testirm.comein.cn';
//   net_url = 'https://testnet.comein.cn';
//   srs_url = 'https://testsrs.comein.cn';
//   html = 'https://testserver.comein.cn/comein-files/';
//   pdf_viewer_url = 'https://testmobile.comein.cn/pdfviewer/web/viewer.html?file=';
//   file_viewer_url = 'https://file-view-test.comein.cn/onlinePreview?url=';
//   mobile_url = 'https://testmobile.comein.cn';
//   comeinUrl = 'https://testserver.comein.cn/comein';
//   webinapp_url = 'https://testserver.comein.cn/comein-files/static/webinapp/#/';
//   mobile_institute_url = 'https://testmobile.comein.cn/mobile/institute/home?comein_channel=';
//   portal_homepage = 'https://testportal.comein.cn';
//   portal_roadshow_url = 'https://testportal.comein.cn/roadshow/home/';
//   net_roadshow_url = 'https://testnet.comein.cn/roadshow/home/';
//   openmonitor_url = 'https://openmonitor-test.comein.cn';
//   srs_mobile_url = 'https://srs-m-test.comein.cn';
//   clientUrl = 'https://testclient.comein.cn';
//   origin = 'https://test-brm.comein.cn';
//   onlinePreviewMobile = 'https://testmobile.comein.cn/onlinePreview/onlinePreview?url=';
//   cloudonlinePreviewMobile = 'https://testmobile.comein.cn/mobile/cloud-preview?documentId=';
//   slsProject = 'comein-web-dev';
// }

// export const HTTPHOST = httpHost;
// export const HOST = host;
// export const BOSH_SERVICE = bosh_service;
// export const FILE_UPLOAD = file_upload;
// export const IMAGE_UPLOAD = image_upload;
// export const WHITELIST_DOWNLOAD = whitelist_download;
// export const GFHOST = gfHost;
// export const OUTBOUNDCALL_DOWNLOAD = outBoundCall_download;
// export const SOCKETURL = socket_url;
// export const SOCKETIP = socket_ip;
// export const IRMURL = irm_url;
// export const NETURL = net_url;
// export const PDFVIEWERURL = pdf_viewer_url;
// export const FILE_VIEWER_URL = file_viewer_url;
// export const SRSURL = srs_url;
// export const htmlUrl = html;
// export const MOBILEURL = mobile_url;
// export const COMEINURL = comeinUrl;
// export const WEBINAPPURL = webinapp_url;
// export const MOBILEINSTITUTEURL = mobile_institute_url;
// export const PORTALHOMEPAGE = portal_homepage;
// export const PORTALROADSHOWURL = portal_roadshow_url;
// export const NETROADSHOWURL = net_roadshow_url;
// export const CLIENT_URL = clientUrl;
// export const OPENMONITOR_URL = openmonitor_url;
// export const SRSMOBILEURL = srs_mobile_url;
// export const ORIGIN = origin;
// export const ONLINEPREVIEWMOBILE = onlinePreviewMobile;
// export const CLOUDONLINEPREVIEWMOBILE = cloudonlinePreviewMobile;
// export const SLS_PROJECT = slsProject;

export const HTTPHOST = ENV_DATA.VITE_SERVER_MAIN;
export const HOST = ENV_DATA.VITE_PHP_HOST;
export const IMAGE_UPLOAD = ENV_DATA.VITE_IMAGE_UPLOAD_URL;
export const IRMURL = ENV_DATA.VITE_IRM_URL;
export const PDFVIEWERURL = ENV_DATA.VITE_PDF_VIEWER_URL;
export const MOBILEURL = ENV_DATA.VITE_MOBILE_MAIN;
export const COMEINURL = ENV_DATA.VITE_COMEIN_URL;
export const PORTALHOMEPAGE = ENV_DATA.VITE_HOST_ROADSHOW;
export const NETROADSHOWURL = ENV_DATA.VITE_NETROADSHOWURL;
export const CLIENT_URL = ENV_DATA.VITE_CLIENT_URL;
export const OPENMONITOR_URL = ENV_DATA.VITE_OPENMONITOR_URL;
export const SRSMOBILEURL = ENV_DATA.VITE_SRS_MOBILE_URL;
export const ORIGIN = ENV_DATA.VITE_BRM_MAIN;
export const ONLINEPREVIEWMOBILE = ENV_DATA.VITE_ONLINE_PREVIEW_MOBILE;
